import { FC, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import OldNotification from './components/Notification';
import NewNotification from './components/NewNotification';

const Notification: FC<Props> = (props) => {
  const [showOldNotification, setShowOldNotification] = useState(false);

  const toggleShowOldNotification = () => {
    setShowOldNotification(prev => !prev);
  }

  if (!showOldNotification) {
    return <NewNotification {...props} onToggle={toggleShowOldNotification} />;
  }

  return (
    <OldNotification
      {...props}
      onToggle={toggleShowOldNotification}
    />
  )
}

const mapState = (state: IGlobalReducerState) => ({
  ...state.notification,
  obrasList: state.obra.ObrasList,
  isLoadingListAll: state.notification.isLoadingListAll,
  userInfo: state.auth.userInfo,
  isShellCollapsed: state.obra.isCollapsed,
  externalGlobalLoading: state.activities.externalGlobalLoading,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(Notification);
